// Styles for MerchandisingPortalModal go here.
import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

//border is added for white background to make the component visible
export const StyledMerchandisingPortalModal = styled.div`
  padding-top: ${toRem(98)};
  @media ${baseVariables.mediaQuery.md} {
    padding-top: ${toRem(198)};
  }
  @media ${baseVariables.mediaQuery.lg} {
    padding-top: ${toRem(210)};
  }
  .merchandising-portal-modal {
    position: relative;
    border: ${baseVariables.border['borderWidth02']} solid ${baseVariables.color['neutral20']};
    border-radius: ${baseVariables.border['borderRadiusDefault']};
    border-radius: ${toRem(14)};

    &__image {
      max-width: ${toRem(204)};
      @media ${baseVariables.mediaQuery.md} {
        max-width: ${toRem(316)};
      }
      @media ${baseVariables.mediaQuery.lg} {
        max-width: ${toRem(412)};
      }
      &-container {
        margin-top: -${toRem(40)};
        @media ${baseVariables.mediaQuery.md} {
          margin-top: -${toRem(126)};
        }
        @media ${baseVariables.mediaQuery.lg} {
          margin-top: -${toRem(160)};
        }
      }
    }
    &__content {
      width: 100%;
      p {
        margin: 0;
      }
    }

    &__button {
      width: ${toRem(164)};
      @media ${baseVariables.mediaQuery.md} {
        width: ${toRem(180)};
      }
      @media ${baseVariables.mediaQuery.lg} {
        width: ${toRem(206)};
      }
    }
    &__footer {
      background-color: rgb(255, 153, 98);
      width: 100%;
      border-radius: 0 0 ${toRem(14)} ${toRem(14)};
    }

    &__variations {
      .total-amount {
        color: ${baseVariables.color.merch20};
      }
    }

    &__badge {
      background: ${baseVariables.color['neutral20']};
      border-radius: ${toRem(4)};
      &-container {
        position: absolute;
        top: ${toRem(24)};
        right: ${toRem(24)};
      }
    }
  }
`;
